import React, { FC } from 'react';

import TimelineItemSliderItem from '../TimelineItemSliderItem';
import TimelineItemSliderControls from '../TimelineItemSliderControls';
import TimelineItemSliderCurrent from '../TimelineItemSliderCurrent';

import { ITimelineItemSliderContainer } from './interfaces';

import './styles.scss';

// time line item slider container
const TimelineItemSliderContainer: FC<ITimelineItemSliderContainer> = ({
  current,
  direction,
  last,
  items,
  onPrevNext,
}) => {
  // render
  return (
    <div
      className="time-line-item-slider-container">
      {items && items.map((item: any, index: number) => (
        <TimelineItemSliderItem
          active={current === index}
          dir={direction}
          last={last === index}
          item={item}
          key={index} />))}

        <TimelineItemSliderCurrent
          current={current + 1}
          total={items.length} />

        <TimelineItemSliderControls
          current={current}
          count={items.length}
          onPrevNext={onPrevNext} />
    </div>
  );
};

export default TimelineItemSliderContainer;